module.exports = __webpack_public_path__ + "static/media/how-it-works-step-2.23413d50.jpg";